/**
 * Variant Popup Handler
 * Shows popup with all variants for products with multiple options
 */

document.addEventListener('DOMContentLoaded', function() {
  const popup = document.querySelector('[data-variant-popup]');
  if (!popup) {
    console.error('Variant popup not found');
    return;
  }

  const popupContent = popup.querySelector('[data-popup-content]');
  const popupTitle = popup.querySelector('[data-popup-title]');
  const closeButtons = popup.querySelectorAll('[data-variant-popup-close]');

  // Open popup
  function openPopup(productHandle, productTitle) {
    console.log('Opening popup for:', productHandle);
    popup.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    if (productTitle) {
      popupTitle.textContent = productTitle;
    }

    // Load variants
    loadVariants(productHandle);
  }

  // Close popup
  function closePopup() {
    popup.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    popupContent.innerHTML = '';
  }

  // Load product variants
  async function loadVariants(productHandle) {
    popupContent.innerHTML = '<div class="variant-popup__loading">Loading variants...</div>';

    try {
      const response = await fetch(`/products/${productHandle}.js`);
      if (!response.ok) throw new Error('Product not found');

      const product = await response.json();
      console.log('Product loaded:', product);
      renderVariants(product);
    } catch (error) {
      console.error('Error loading variants:', error);
      popupContent.innerHTML = '<div class="variant-popup__loading">Error loading variants. Please try again.</div>';
    }
  }

  // Render variants
  function renderVariants(product) {
    const variantsHTML = product.variants.map(variant => {
      const price = variant.price / 100;
      const comparePrice = variant.compare_at_price ? variant.compare_at_price / 100 : null;
      const hasDiscount = comparePrice && comparePrice > price;
      const discount = hasDiscount ? Math.round(((comparePrice - price) / comparePrice) * 100) : 0;
      const isAvailable = variant.available;
      const currencySymbol = window.headerCurrencySymbol || '₹';

      // Build variant options display (e.g., "Size: Small", "Color: Red")
      let variantOptionsHTML = '';
      if (product.options && product.options.length > 0 && variant.options) {
        const optionPairs = product.options.map((option, index) => {
          // option can be either a string or an object with 'name' property
          const optionName = typeof option === 'string' ? option : (option.name || option);
          const optionValue = variant.options[index];
          // Skip if option name is "Title" (default single variant)
          if (optionName === 'Title') return '';
          return `<span class="variant-item__option"><strong>${optionName}:</strong> ${optionValue}</span>`;
        }).filter(o => o !== '');

        if (optionPairs.length > 0) {
          variantOptionsHTML = `<div class="variant-item__options">${optionPairs.join('')}</div>`;
        }
      }

      return `
        <div class="variant-item ${!isAvailable ? 'variant-item--unavailable' : ''}">
          <div class="variant-item__info">
            ${variantOptionsHTML}
            <div class="variant-item__price">
              ${hasDiscount ? `
                <span class="variant-item__price-sale">${currencySymbol}${price.toFixed(2)}</span>
                <span class="variant-item__price-compare">${currencySymbol}${comparePrice.toFixed(2)}</span>
                <span class="variant-item__discount">${discount}% OFF</span>
              ` : `
                <span class="variant-item__price-current">${currencySymbol}${price.toFixed(2)}</span>
              `}
            </div>
          </div>
          <button
            type="button"
            class="variant-item__add-btn"
            data-variant-add
            data-variant-id="${variant.id}"
            ${!isAvailable ? 'disabled' : ''}
          >
            ${isAvailable ? 'Add to Cart' : 'Sold Out'}
          </button>
        </div>
      `;
    }).join('');

    popupContent.innerHTML = variantsHTML;

    // Add event listeners to add-to-cart buttons
    const addButtons = popupContent.querySelectorAll('[data-variant-add]');
    addButtons.forEach(btn => {
      btn.addEventListener('click', handleAddToCart);
    });
  }

  // Handle add to cart
  async function handleAddToCart(e) {
    const button = e.currentTarget;
    const variantId = button.dataset.variantId;
    const originalText = button.textContent;

    button.textContent = 'Adding...';
    button.disabled = true;

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      });

      if (!response.ok) throw new Error('Failed to add to cart');

      const data = await response.json();

      // Update cart count if cart drawer exists
      if (typeof window.updateCartCount === 'function') {
        window.updateCartCount();
      }

      // Close popup
      closePopup();

      // Show success message or open cart drawer
      if (typeof window.openCartDrawer === 'function') {
        window.openCartDrawer(true);
      } else {
        // Fallback: reload page to show cart update
        window.location.href = '/cart';
      }

    } catch (error) {
      console.error('Error adding to cart:', error);
      button.textContent = 'Error - Try Again';
      setTimeout(() => {
        button.textContent = originalText;
        button.disabled = false;
      }, 2000);
    }
  }

  // Event listeners for opening popup
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-variant-popup-trigger]');
    if (trigger) {
      e.preventDefault();
      console.log('Variant popup trigger clicked');
      const productHandle = trigger.dataset.productHandle;
      const productTitle = trigger.closest('[data-product-card]')?.querySelector('[data-title]')?.dataset.title || 'Select Variant';
      openPopup(productHandle, productTitle);
    }
  });

  // Event listeners for closing popup
  closeButtons.forEach(btn => {
    btn.addEventListener('click', closePopup);
  });

  // Close on escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && popup.getAttribute('aria-hidden') === 'false') {
      closePopup();
    }
  });

  console.log('Variant popup initialized');
});
